import React from 'react';

import FormBase from '../FormBase';
import RadioButtonGroup from '../../../../components/Buttons/RadioButtonGroup';
import TextField from '../../../../components/Textfields/TextField';
import SelectSystemCode from '../../../../components/Dropdown/SelectSystemCode';
import DateTimePicker from '../../../../components/Textfields/DateTimePicker';
import AutoCompletePlace from '../../../../components/AutoComplete/AutoCompletePlace';
import AutoCompleteCountry from '../../../../components/AutoComplete/AutoCompleteCountry';
import AutoCompleteState from '../../../../components/AutoComplete/AutoCompleteState';
import PhoneNumber from '../../../../components/Textfields/PhoneNumber';
import InputMask from 'react-input-mask';

import { useAccountContext } from '../Data/accountContext';
import { hasError, validateTrustedContact } from '../Data/validation';
import { saveTrustedContact } from '../../../../services/RegistrationService';

export default function FormTrustedContact() {
  const { account, setAccount, setAccountResponse } = useAccountContext();
  const [validation, setValidation] = React.useState({});

  const handleChange = (e, autocomplete) => {
    const copy = { ...account };

    // if from autocomplete place
    if (autocomplete?.address1) {
      copy.trustedContact.address1 = autocomplete.address1;
      copy.trustedContact.address2 = autocomplete.address2;
      copy.trustedContact.city = autocomplete.city;
      copy.trustedContact.state = autocomplete.state;
      copy.trustedContact.country = autocomplete.country;
      copy.trustedContact.zip = autocomplete.zipCode;
    } else {
      const input = e.currentTarget.name ? e.currentTarget : e.target;

      // if field is country set the state to empty
      // `ountry` to also catch primaryCountry and country without having to use tolowercase
      if (
        input.name.includes('ountry') &&
        (input.value === 'US' ||
          (input.value !== 'US' && copy.trustedContact.country === 'US'))
      ) {
        copy.trustedContact.state = '';
      }

      copy.trustedContact[input.name] = input.value;
    }

    setAccount({ ...copy });
  };

  const handleSave = async () => {
    let errs = validateTrustedContact(account.trustedContact);
    setValidation(errs);
    if (hasError(errs)) {
      console.log('trusted contact errs', errs);
      return { acct: account, err: true };
    }

    const request = account.trustedContact;

    if (account.trustedContact.relationship === 'Other') {
      request.relationship = 'Other ' + request.other;
    }

    const res = await saveTrustedContact(request);
    const copy = { ...account, trustedContact: res };
    setAccountResponse(copy);

    return { acct: copy, err: false };
  };

  return (
    <FormBase
      name="trusted-contact"
      header="Trusted Contact"
      subHeader=""
      faq="Trusted Contact"
      save={handleSave}
    >
      <form className="trusted-contact-form-w" autoComplete="off">
        <input type="hidden" autoComplete="off" />
        <RadioButtonGroup
          name="haveTrustedContact"
          label="Do you have a trusted contact?"
          error={!!validation.haveTrustedContact}
          msg={validation.haveTrustedContact}
          value={account?.trustedContact?.haveTrustedContact || null}
          options={['Yes', 'No']}
          onChange={(e) => {
            const copy = { ...account };
            copy.trustedContact.haveTrustedContact = e.target.value;
            setAccount(copy);
          }}
        />
        {account?.trustedContact?.haveTrustedContact === 'Yes' && (
          <div>
            <div className="grd-row">
              <div className="grd-cell">
                <TextField
                  required={true}
                  error={!!validation.firstName}
                  msg={validation.firstName}
                  max={50}
                  name="firstName"
                  label="First Name"
                  placeholder="First Name"
                  type="text"
                  value={account.trustedContact?.firstName}
                  onChange={handleChange}
                />
              </div>
              <div className="grd-cell">
                <TextField
                  max={20}
                  name="middleName"
                  label="Middle Name"
                  placeholder="Middle Name (Optional)"
                  type="text"
                  value={account.trustedContact?.middleName}
                  onChange={handleChange}
                />
              </div>
              <div className="grd-cell">
                <TextField
                  required={true}
                  error={!!validation.lastName}
                  msg={validation.lastName}
                  max={20}
                  name="lastName"
                  label="Last Name"
                  placeholder="Last Name"
                  type="text"
                  value={account.trustedContact?.lastName}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <SelectSystemCode
                  required={true}
                  error={!!validation.emailType}
                  msg={validation.emailType}
                  name="emailType"
                  label="Email Type"
                  placeholder="Email Type"
                  type="Contact Info Type"
                  subType="Email Type"
                  value={account.trustedContact?.emailType}
                  onChange={handleChange}
                />
              </div>
              <div className="grd-cell">
                <TextField
                  required={true}
                  error={!!validation.email}
                  msg={validation.email}
                  max={50}
                  name="email"
                  label="Email Address"
                  placeholder="Email Address"
                  type="text"
                  value={account.trustedContact?.email}
                  onChange={handleChange}
                />
              </div>
              <div className="grd-cell">
                <DateTimePicker
                  required={true}
                  error={!!validation.dateOfBirth}
                  msg={validation.dateOfBirth}
                  type="date"
                  name="dateOfBirth"
                  label="Birth Date"
                  value={account.trustedContact?.dateOfBirth || ''}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <SelectSystemCode
                  required={true}
                  error={!!validation.identificationType}
                  msg={validation.identificationType}
                  name="identificationType"
                  label="Identification Type"
                  placeholder="Identification Type"
                  type="Identification"
                  subType="Client"
                  value={account.trustedContact?.identificationType}
                  onChange={handleChange}
                />
              </div>
              <div className="grd-cell">
                {['SSN', 'TIN', 'GIIN'].includes(
                  account.trustedContact.identificationType
                ) ? (
                  <InputMask
                    mask={
                      account.trustedContact.identificationType === 'SSN'
                        ? '999-99-9999'
                        : account.trustedContact.identificationType === 'GIIN'
                        ? '******.*****.**.***'
                        : '99-9999999'
                    }
                    value={account.trustedContact?.identificationValue}
                    beforeMaskedValueChange={(newId, oldId) => {
                      if (newId.value !== oldId.value) {
                        handleChange({
                          currentTarget: {
                            name: 'identificationValue',
                            value: newId.value,
                          },
                        });
                      }

                      return {
                        value: newId.value,
                        selection: newId.selection,
                      };
                    }}
                  >
                    {() => (
                      <TextField
                        fullWidth={true}
                        error={!!validation.identificationValue}
                        msg={validation.identificationValue}
                        id="identificationValue"
                        name="identificationValue"
                        label="ID"
                        placeholder="ID"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  </InputMask>
                ) : (
                  <TextField
                    required={true}
                    error={!!validation.identificationValue}
                    msg={validation.identificationValue}
                    max={
                      account.trustedContact.identificationType === 'Passport' ? 30 : 13
                    }
                    name="identificationValue"
                    label="ID"
                    placeholder="ID"
                    type="text"
                    value={account.trustedContact?.identificationValue}
                    onChange={handleChange}
                  />
                )}
              </div>
              <div className="grd-cell"></div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <SelectSystemCode
                  required={true}
                  error={!!validation.relationship}
                  msg={validation.relationship}
                  name="relationship"
                  label="Relationship"
                  placeholder="Relationship"
                  type="Relationship"
                  subType="Client Site"
                  value={account.trustedContact?.relationship}
                  onChange={handleChange}
                />
              </div>
              {account.trustedContact.relationship === 'Other' && (
                <div className="grd-cell">
                  <TextField
                    required={account.trustedContact.relationship === 'Other'}
                    error={!!validation.other}
                    msg={validation.other}
                    max={20}
                    name="other"
                    label="Other"
                    placeholder="Please Specify"
                    type="text"
                    value={account.trustedContact?.other}
                    onChange={handleChange}
                  />
                </div>
              )}
              <div className="grd-cell">
                <SelectSystemCode
                  required={true}
                  error={!!validation.phoneType}
                  msg={validation.phoneType}
                  name="phoneType"
                  label="Phone Type"
                  placeholder="Phone Type"
                  type="Contact Info Type"
                  subType="Phone Type"
                  value={account.trustedContact?.phoneType}
                  onChange={handleChange}
                />
              </div>
              <div className="grd-cell">
                <PhoneNumber
                  required={true}
                  error={!!validation.phone}
                  msg={validation.phone}
                  name="phone"
                  label="Phone Number"
                  value={account.trustedContact?.phone}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <SelectSystemCode
                  required={true}
                  error={!!validation.addressType}
                  msg={validation.addressType}
                  name="addressType"
                  label="Address Type"
                  placeholder="Address Type"
                  type="Address Type"
                  subType="Client Site"
                  value={account.trustedContact?.addressType}
                  onChange={handleChange}
                />
              </div>
              <div className="grd-cell">
                <AutoCompletePlace
                  required={true}
                  error={!!validation.address1}
                  msg={validation.address1}
                  max={100}
                  name="address1"
                  label="Address 1"
                  placeholder="Address 1"
                  value={account.trustedContact?.address1}
                  onChange={handleChange}
                  setAddressData={(name, address) => {
                    handleChange({ currentTarget: { name } }, address);
                  }}
                />
              </div>
              <div className="grd-cell">
                <TextField
                  max={100}
                  name="address2"
                  label="Address 2"
                  placeholder="Address 2"
                  type="text"
                  value={account.trustedContact?.address2}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <TextField
                  required={true}
                  error={!!validation.city}
                  msg={validation.city}
                  max={80}
                  name="city"
                  label="City"
                  placeholder="City"
                  type="text"
                  value={account.trustedContact?.city}
                  onChange={handleChange}
                />
              </div>
              <div className="grd-cell">
                {account?.trustedContact?.country !== 'US' ? (
                  <TextField
                    max={50}
                    name="addressState"
                    label="State"
                    placeholder="State"
                    type="text"
                    value={account.trustedContact?.addressState}
                    onChange={handleChange}
                  />
                ) : (
                  <AutoCompleteState
                    required={true}
                    error={!!validation.addressState}
                    msg={validation.addressState}
                    name="addressState"
                    label="State"
                    placeholder="State"
                    value={account.trustedContact?.addressState}
                    onChange={handleChange}
                  />
                )}
              </div>
              <div className="grd-cell">
                <AutoCompleteCountry
                  required={true}
                  error={!!validation.country}
                  msg={validation.country}
                  name="country"
                  label="Country"
                  placeholder="Country"
                  value={account.trustedContact?.country}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="grd-row">
              <div className="grd-cell">
                <InputMask
                  mask={
                    account.trustedContact?.country === 'CA' ? '*** ***' : '**********'
                  }
                  value={account.trustedContact?.zip}
                  beforeMaskedValueChange={(newZip, oldZip) => {
                    if (newZip.value !== oldZip.value) {
                      handleChange({
                        currentTarget: {
                          name: 'zip',
                          value: newZip.value,
                        },
                      });
                    }

                    return {
                      value: newZip.value,
                      selection: newZip.selection,
                    };
                  }}
                >
                  {() => (
                    <TextField
                      fullWidth={true}
                      error={!!validation?.zip}
                      msg={validation?.zip}
                      required={
                        account.trustedContact?.country === 'US' ||
                        account.trustedContact?.country === 'CA'
                      }
                      id="zip"
                      name="zip"
                      label="Zip Code"
                      placeholder="Zip Code"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                </InputMask>
              </div>
              <div className="grd-cell"></div>
              <div className="grd-cell"></div>
            </div>
          </div>
        )}
      </form>
    </FormBase>
  );
}
